import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { NavItemEnum } from '../../../constants/routing/NavItems';
import { FeaturesLayoutUI } from '../../merch-card/features-display/FeaturesLayoutUI';
import ChecklistItemTranslated from '../ChecklistItemTranslated';

// @ts-expect-error svg import
import DefaultCreditsCalloutImage from 'bender-url!../../../img/creditsCallout/generic.svg';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreditsCalloutImageMap = {
  [NavItemEnum.MARKETING]: DefaultCreditsCalloutImage,
  [NavItemEnum.SALES]: DefaultCreditsCalloutImage,
  [NavItemEnum.SERVICE]: DefaultCreditsCalloutImage,
  [NavItemEnum.OPERATIONS]: DefaultCreditsCalloutImage,
  [NavItemEnum.CONTENT]: DefaultCreditsCalloutImage,
  [NavItemEnum.SUITE]: DefaultCreditsCalloutImage,
  [NavItemEnum.COMMERCE]: DefaultCreditsCalloutImage
};
const getCreditsCalloutFeatureHighlights = navItem => {
  switch (navItem) {
    case NavItemEnum.MARKETING:
    case NavItemEnum.SALES:
    case NavItemEnum.SERVICE:
    case NavItemEnum.DATA:
    case NavItemEnum.CONTENT:
    case NavItemEnum.SUITE:
    case NavItemEnum.COMMERCE:
    default:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.creditsCallout.featureHighlights.default.feature_1"
      }, "feature_1"), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.creditsCallout.featureHighlights.default.feature_2"
      }, "feature_2"), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.creditsCallout.featureHighlights.default.feature_3"
      }, "feature_3"), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.creditsCallout.featureHighlights.default.feature_4"
      }, "feature_4")];
  }
};
export const CreditsCalloutSection = ({
  navItem
}) => {
  const isMobile = useIsMobile();
  const creditsCalloutImage = CreditsCalloutImageMap[navItem] || DefaultCreditsCalloutImage;
  const features = getCreditsCalloutFeatureHighlights(navItem);
  const FeaturesListSection = features.map((feature, index) => {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: index > 0 ? '200' : undefined,
      children: /*#__PURE__*/_jsx(ChecklistItemTranslated, {
        message: feature
      })
    }, index);
  });
  return /*#__PURE__*/_jsx(CardWrapper, {
    borderRadius: "300",
    blockSize: "100%",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
        children: [/*#__PURE__*/_jsx(View, {
          flex: "1",
          padding: "1000",
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "0",
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-25",
              padding: "0",
              marginBlockEnd: "200",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.pages.hubspot-credits.creditsCallout.heading"
              })
            }), /*#__PURE__*/_jsx(Text, {
              typography: "heading-400",
              color: "text-core-default",
              padding: "0",
              marginBlockEnd: "700",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.pages.hubspot-credits.creditsCallout.title"
              })
            }), /*#__PURE__*/_jsx(FeaturesLayoutUI, {
              loading: false,
              FeaturesListSection: FeaturesListSection
            }), /*#__PURE__*/_jsx(View, {
              inlineSize: "fit-content",
              marginBlockStart: "700",
              children: /*#__PURE__*/_jsx(Button, {
                use: "primary-white",
                borderColor: "border-core-default",
                borderWidth: "100",
                borderStyle: "solid",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "pricingPage.pages.hubspot-credits.creditsCallout.cta"
                })
              })
            })]
          })
        }), !isMobile && /*#__PURE__*/_jsx(View, {
          flex: "2",
          paddingBlockStart: "1000",
          blockSize: "100%",
          alignSelf: "end",
          children: /*#__PURE__*/_jsx(Image, {
            src: creditsCalloutImage,
            alt: "Credits Callout Placeholder image",
            width: "100%",
            height: "100%",
            padding: "0"
          })
        })]
      })
    })
  });
};